module.exports = __webpack_public_path__ + "img/EUfondovi.f797d015.png";